import { cn } from "../lib/cn";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  message: string;
  action?: { label: string; onClick: () => void };
  className?: string;
}

export function EmptyState({
  icon,
  message,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 py-12",
        className,
      )}
    >
      {icon && <div className="text-text-muted">{icon}</div>}
      <p className="text-text-muted font-mono text-sm">{message}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="border-gold-dim text-gold hover:border-gold cursor-pointer rounded-sm border bg-transparent px-4 py-2 font-mono text-[10px] uppercase tracking-[0.15em]"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
